<template>
  <transition
    name="fade-scale"
    appear
  >
    <div
      v-if="visible"
      class="flex flex-col items-center justify-center h-screen bg-white"
    >
      <DotLottieVue
        :src="animationSource"
        style="height: 300px; width: 300px"
        autoplay
        loop
      />
      <p class="mt-4 text-gray-600 text-base animate-pulse">
        {{ message }}
      </p>
    </div>
  </transition>
</template>

<script setup>
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";
import { computed, defineProps, ref } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: "login", // "login" | "logout"
  },
  userType: {
    type: String,
    default: "client", // "client" | "internal"
  },
});

const visible = ref(true);

const animationSource = computed(() => {
  if (props.type === "logout") {
    return props.userType === "internal"
      ? "https://lottie.host/773a4b22-0ea5-4f38-855c-4309b79f433b/nMaglXUBsG.lottie"
      : "https://lottie.host/773a4b22-0ea5-4f38-855c-4309b79f433b/nMaglXUBsG.lottie"; // Client logout
  } else {
    return props.userType === "internal"
      ? "https://lottie.host/d6243f32-2d2d-449d-b012-36be040cc8e5/V5uI6MaeDj.lottie"
      : "https://lottie.host/d6243f32-2d2d-449d-b012-36be040cc8e5/V5uI6MaeDj.lottie"; // Client login
  }
});

const message = computed(() => {
  if (props.type === "logout") {
    return props.userType === "internal"
      ? "Logging you out. Syncing your session..."
      : "Logging you out. Please wait while we safely sign you off.";
  } else {
    return props.userType === "internal"
      ? "Launching your dashboard. Preparing internal tools..."
      : "Launching your dashboard. Getting things ready for you!";
  }
});
</script>

<style scoped>
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
